import React from "react";

import {
  formatCurrency,
} from "../utils/publicOffer.utils";


const PublicOfferItems = ({
  publicOffer,
}) => {

  const items =
    publicOffer?.items || [];

  const currency =
    publicOffer?.offer?.currency ||
    "INR";


  return (
    <section className="public-offer-items">

      <div className="public-offer-section-header">

        <h2>
          Items
        </h2>

      </div>


      <div className="public-offer-items-wrapper">

        <table className="public-offer-items-table">

          <thead>

            <tr>

              <th>
                #
              </th>

              <th>
                Description
              </th>

              <th>
                Quantity
              </th>

              <th>
                Unit Price
              </th>

              <th>
                Discount
              </th>

              <th>
                Tax
              </th>

              <th>
                Total
              </th>

            </tr>

          </thead>


          <tbody>

            {items.length === 0 ? (

              <tr>

                <td
                  colSpan="7"
                  className="public-offer-empty"
                >
                  No items found.
                </td>

              </tr>

            ) : (

              items.map(
                (item, index) => (

                  <tr
                    key={
                      item.id ||
                      index
                    }
                  >

                    <td>
                      {index + 1}
                    </td>

                    <td>
                      {item.description}
                    </td>

                    <td>
                      {item.quantity}
                    </td>

                    <td>
                      {formatCurrency(
                        item.unitPrice,
                        currency
                      )}
                    </td>

                    <td>
                      {formatCurrency(
                        item.discountAmount,
                        currency
                      )}
                    </td>

                    <td>
                      {formatCurrency(
                        item.taxAmount,
                        currency
                      )}
                    </td>

                    <td>
                      <strong>
                        {formatCurrency(
                          item.totalAmount,
                          currency
                        )}
                      </strong>
                    </td>

                  </tr>

                )
              )

            )}

          </tbody>

        </table>

      </div>

    </section>
  );
};


export default PublicOfferItems;
